export const finished = async (id) => {
    try {
        fetch(`https://blue-moon-admin.vercel.app/tasks/increase/${id}`, {
            method: 'PUT',
            headers: {
            },
        });
    } catch (error) {
        console.error('Error:', error);
    }
};